export const FETCH_LOCAL_IO_REQUEST = '[LocalIO] FETCH_LOCAL_IO_REQUEST';
export const FETCH_LOCAL_IO_SUCCESS = '[LocalIO] FETCH_LOCAL_IO_SUCCESS';
export const FETCH_LOCAL_IO_FAILURE = '[LocalIO] FETCH_LOCAL_IO_FAILURE';
